import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {when} from 'lit/directives/when.js';
import store from '../../../store';
import {selectSpcIsSatisfied} from '../../../selectors';


@customElement('solar-specsheet')
export class SolarSpecsheet extends connect(store)(LitElement) {

	static styles = [
		//cssProperties,
		css`
			:host {
				container-type: inline-size;
			}

			@media screen {
				.page {
					max-width: 1400px;
					width: 90%;
					box-sizing: border-box;
					margin: 40px auto 20px auto;
					box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.25);
				}
			}
			@media print {
				.page {
					margin: 0;
					box-shadow: none;
				}
			}
		`
	];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.spcIsSatisfied = selectSpcIsSatisfied(state); // selectFeatureModelCompletionPercentage(state) >= 100; // state.decisions.data.isSatisfied;
	}

	render() {
		return html`
			<family-overview-page class="page">
				<family-overview></family-overview>
			</family-overview-page>
			<family-overview-page class="page">
				<model-overview></model-overview>
			</family-overview-page>
			<shared-specsheet-page class="page">
				<shared-technical-data-page></shared-technical-data-page>
			</shared-specsheet-page>
			<shared-specsheet-page class="page">
				<shared-tender-text-page></shared-tender-text-page>
			</shared-specsheet-page>
			<shared-specsheet-page class="page">
				<solar-light-engine></solar-light-engine>
			</shared-specsheet-page>

		`;
	}
}
